import { render, staticRenderFns } from "./stayReceiveList.vue?vue&type=template&id=47041c87&scoped=true"
import script from "./stayReceiveList.vue?vue&type=script&lang=js"
export * from "./stayReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47041c87",
  null
  
)

export default component.exports